import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import logo from "../assets/images/logo.png";
import logoWhite from "../assets/images/logo-white.png";

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <header
      className={`navbar navbar-expand-lg fixed-top bg-${theme}`}
      data-bs-theme={theme}
    >
      <div class="container">
        {/* <!-- Navbar brand (Logo) --> */}
        <Link class="navbar-brand pe-sm-3" to="/">
          <span class="text-primary flex-shrink-0 me-2">
            <img
              src={logo}
              className="img-fluid d-dark-mode-none"
              style={{ maxWidth: "40px" }}
              alt="logo"
            />
            <img
              src={logoWhite}
              className="d-none img-fluid d-dark-mode-block"
              style={{ maxWidth: "40px" }}
              alt="logo"
            />
          </span>
          Hiren
        </Link>

        {/* <!-- Mobile menu toggler (Hamburger) --> */}
        <button
          class="navbar-toggler ms-sm-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        {/* <!-- Navbar collapse (Main navigation) --> */}
        <nav class={`collapse navbar-collapse bg-${theme}`} id="navbarNav">
          <ul class="navbar-nav navbar-nav-scroll ms-auto">
            <li class="nav-item">
              <Link class="nav-link" to="/">
                Home
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="/about">
                About
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="/portfolio">
                Portfolio
              </Link>
            </li>
            {/* <li class="nav-item">
              <Link class="nav-link" to="/contact">
                Contact
              </Link>
            </li> */}
          </ul>
          <div className="form-check form-switch ms-3 mb-lg-0">
            <input
              className="form-check-input"
              type="checkbox"
              id="theme-toggle"
              checked={theme === "dark"}
              onChange={toggleTheme}
            />
            <label className="form-check-label" htmlFor="theme-toggle">
              {theme === "light" ? "Light" : "Dark"}
            </label>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
